import React from "react";
import "../Content/CSS/Flightloader.css";

/**
 * Usage:
 * <FlightLoader
 *   show={loading}
 *   fromCode={from.code}
 *   toCode={to.code}
 * />
 */
function FlightLoader({ show, fromCode = "DEL", toCode = "BOM" }) {
    if (!show) return null;

    return (
        <div className="flightLoaderOverlay">
            <div className="flightLoaderCard">
                <div className="flightLoaderPath">
                    {/* Left city */}
                    <div className="flCity flCityLeft">
                        <span className="flGlobe flGlobeLeft" />
                        <span className="flCode">{fromCode}</span>
                    </div>

                    {/* Dashed curved path */}
                    <svg className="flCurve" viewBox="0 0 300 100" preserveAspectRatio="none">
                        <path
                            id="flPlanePath"
                            d="M 25 75 Q 150 -10 275 75"
                            fill="none"
                            stroke="#bcd3e6"
                            strokeWidth="2"
                            strokeDasharray="6 8"
                        />
                    </svg>

                    {/* Animated plane */}
                    <div className="flPlaneWrap">
                        <span className="flPlane">✈</span>
                    </div>

                    {/* Center sync badge */}
                    <div className="flSyncBadge">
                        <span className="flSyncDot" />
                        sync
                    </div>

                    {/* Right city */}
                    <div className="flCity flCityRight">
                        <span className="flGlobe flGlobeRight" />
                        <span className="flCode">{toCode}</span>
                    </div>
                </div>

                <p className="flCaption">
                    Connecting <strong>{fromCode}</strong> to <strong>{toCode}</strong>...
                </p>
            </div>
        </div>
    );
}

export default FlightLoader;